import React from 'react'

function BigText({
  text,
  light = true,
  absolute = true,
  bottomPosition = 'bottom-[-20%]',
  big = false,
  wrap = false,
}: {
  text: string
  light?: boolean
  absolute?: boolean
  bottomPosition?: string
  big?: boolean
  wrap?: boolean
}) {
  const className = absolute
    ? `absolute ${bottomPosition} left-0 z-10 flex w-full items-end justify-start pointer-events-none`
    : 'flex w-full items-end justify-center'

  return (
    <div className={className}>
      <p
        className={`-z-10  !font-clash font-semibold ${light ? 'text-[#2121210D] opacity-15' : 'text-[#212121] opacity-15'} ${wrap ? 'whitespace-wrap' : 'whitespace-nowrap'} overflow-hidden`}
        style={{
          fontSize: big ? 'clamp(7rem, 8vw, 8rem)' : 'clamp(2rem, 6vw, 6rem)',
        }}
      >
        {text}
      </p>
    </div>
  )
}

export default BigText
